import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import Layout from '../components/Layout';
import { programService } from '../services/firebaseService';
import { Program } from '../types';

const ProgramsPage: React.FC = () => {
  const [programs, setPrograms] = useState<Program[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log('🔄 ProgramsPage: Starting to load programs...');
    programService.getPrograms().then(list => {
      console.log('✅ Programs loaded:', list.length, list);
      console.log('Program details:', list.map(p => ({ id: p.id, title: p.title, isActive: (p as any).isActive })));
      setPrograms(list);
      setLoading(false);
    }).catch((error) => {
      console.error('❌ Error loading programs:', error);
      console.error('Error code:', error.code);
      console.error('Error message:', error.message);
      console.error('Error stack:', error.stack);
      console.error('Full error object:', JSON.stringify(error, null, 2));
      setLoading(false);
    });
  }, []);
  return (
    <Layout>
      <div className="container">
        <h1>Our Programs</h1>
        {loading ? (
          <div className="loading"><div className="spinner" /></div>
        ) : (
          <div className="grid">
            {programs.map((p) => (
              <Link 
                to={`/programs/${p.id}`} 
                key={p.id}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div className="card" style={{ cursor: 'pointer' }}>
                  {p.imageUrl && (
                    <img src={p.imageUrl} alt={p.title} style={{ width: '100%', borderRadius: '8px', marginBottom: '1rem' }} />
                  )}
                  <h3>{p.title}</h3>
                  {p.summary && (
                    <div>
                      <ReactMarkdown
                        components={{
                          p: ({ children }) => <p style={{ marginBottom: '0' }}>{children}</p>,
                          a: ({ href, children }) => (
                            <a href={href} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary)', textDecoration: 'underline' }}>
                              {children}
                            </a>
                          )
                        }}
                      >
                        {p.summary}
                      </ReactMarkdown>
                    </div>
                  )}
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
};

export default ProgramsPage;
